import { Component, Input, OnInit } from '@angular/core';
import { AppSettings } from '../../common/config';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ClipboardService } from 'ngx-clipboard';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { extractYoutubeVideoId } from '../../validators/vimeoYoutubeUrlValidator';

const VIMEO_EMBED_BASE_URL = 'https://player.vimeo.com/video/';
const YOUTUBE_EMBED_BASE_URL = 'https://www.youtube.com/embed/';
const AUTOPLAY_ENABLED = 'autoplay=1&mute=1';
const VIDEO_ID = 'videoId';

@Component({
  selector: 'parse-video-url',
  templateUrl: './parse-video-url.component.html',
  styleUrls: ['./parse-video-url.component.css'],
})
export class ParseVideoUrlComponent implements OnInit {
  @Input() public source: string;
  @Input() public autoplay = false;
  @Input() public videoId = '';

  public trustedUrl: SafeResourceUrl = '';
  public AppSettings = AppSettings;

  constructor(
    private sanitizer: DomSanitizer,
    private clipboardService: ClipboardService,
    private toastr: ToastrService,
    private translateService: TranslateService
  ) {}

  public ngOnInit(): void {
    this.trustedUrl = this.parseUrl();
  }

  public copyShareUrlToClipboard() {
    const href = window.location.href;
    let shareUrl = '';

    if (href.indexOf(this.videoId) > -1) {
      shareUrl = href;
    } else {
      shareUrl = this.removeURLParameter(href, VIDEO_ID);

      const symbol = shareUrl.indexOf('?') > -1 ? '&' : '?';
      shareUrl = `${shareUrl}${symbol}${VIDEO_ID}=${this.videoId}`;
    }

    this.clipboardService.copyFromContent(shareUrl);

    this.toastr.success(
      this.translateService.instant('UNIVERSAL-SHARE_LINK_COPY_SUCCESSFUL'),
      this.translateService.instant('UNIVERSAL-COPY-SUCCESSFUL'),
      { timeOut: 5000 }
    );
  }

  private parseUrl() {
    let url = '';
    let matches;
    const youtubeVideoId = extractYoutubeVideoId(this.source);

    if (this.source.match(AppSettings.VIMEO_URL_REGEX_PATTERN)) {
      matches = AppSettings.VIMEO_URL_REGEX_PATTERN.exec(this.source);
      url = matches && VIMEO_EMBED_BASE_URL + matches[1];
    } else if (youtubeVideoId) {
      url = YOUTUBE_EMBED_BASE_URL + youtubeVideoId;
    }

    if (this.autoplay && url) {
      const symbol = url.indexOf('?') > -1 ? '&' : '?';
      url += symbol + AUTOPLAY_ENABLED;
    }

    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  private removeURLParameter(url: string, parameter: string) {
    const urlParts = url.split('?');

    if (urlParts.length >= 2) {
      const prefix = encodeURIComponent(parameter) + '=';
      const parts = urlParts[1].split(/[&;]/g);

      for (let i = parts.length - 1; i >= 0; i -= 1) {
        if (parts[i].lastIndexOf(prefix, 0) !== -1) {
          parts.splice(i, 1);
        }
      }

      return urlParts[0] + (parts.length > 0 ? '?' + parts.join('&') : '');
    }
    return url;
  }
}
